const Comparison = ({ data }) => {
  if (!data) return null;

  return (
    <section className="py-16 px-6" data-testid="comparison-section">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12 text-center">
          <h2 className="text-4xl lg:text-5xl font-bold mb-4">
            <span className="bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent">
              How many acquisitions
            </span>{' '}
            can your team really handle?
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed max-w-4xl mx-auto">
            {data.subtitle}
          </p>
        </div>

        <div className="bg-gradient-to-br from-purple-600/20 to-blue-600/10 rounded-3xl p-1 shadow-xl">
          <div className="bg-white rounded-3xl p-8 lg:p-12 border border-gray-200">
            <div className="overflow-x-auto mb-8">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-gray-200">
                    <th className="text-left py-4 px-4 font-semibold text-gray-600 uppercase tracking-wide text-xs">
                      Metric
                    </th>
                    <th className="text-left py-4 px-4 font-semibold text-gray-600 uppercase tracking-wide text-xs">
                      Traditional manual process
                    </th>
                    <th className="text-left py-4 px-4 font-semibold text-gray-600 uppercase tracking-wide text-xs">
                      With AcuSightPro
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data.table.map((row, index) => (
                    <tr key={index} className="border-b border-gray-100 last:border-0">
                      <td className="py-4 px-4 font-medium text-gray-900">{row.metric}</td>
                      <td className="py-4 px-4 text-gray-600">{row.manual}</td>
                      <td className="py-4 px-4 text-purple-700 font-semibold">{row.withASP}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="grid lg:grid-cols-2 gap-8 text-sm">
              <div>
                <h4 className="font-semibold text-gray-900 mb-2">Without AcuSightPro</h4>
                <p className="text-gray-600 leading-relaxed">
                  Teams rebuild the same artifacts again and again, with inconsistent formats and limited visibility.
                  One person can safely "own" one big action (maybe two) at a time, and it still takes months to reach a decision-grade view.
                </p>
              </div>
              <div>
                <h4 className="font-semibold text-gray-900 mb-2">With AcuSightPro</h4>
                <p className="text-gray-600 leading-relaxed">
                  ASP ingests documents, structures findings, and drafts first-cut materials automatically.
                  That shift unlocks decision-grade insight in weeks and higher throughput, without compromising oversight.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Comparison;
